<template>
  <div>
    <section-title content="Nivel de discapacidad:" has-line />

    <div class="bg-secondary-3 p-2 rounded">
      <div class="bg-white p-3 rounded border">
        <div class="row align-items-center text-bold">
          <div class="col-md">
            <span class="text-semibold">Porcentaje Ponderado</span>
          </div>
          <div class="col-md">
            <span class="text-semibold">Nivel de Discapacidad</span>
          </div>
          <div class="col-md-5">
            <span class="text-semibold">Interpretación General</span>
          </div>
        </div>

        <div
          v-for="item in value"
          :key="item.id"
          class="row align-items-center my-2 py-2"
        >
          <div class="col-md">{{ item.min }} - {{ item.max }}</div>

          <div class="col-md">
            <span
              class="rounded-pill py-1 px-3 text-semibold"
              :style="badge(item.color)"
            >
              {{ item.name | empty }}
            </span>
          </div>

          <div class="col-md-5">
            {{ item.description | empty }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from '@/mixins/alert.mixin.js';
import SectionTitle from '@/shared/components/SectionTitle.vue';

export default {
  name: 'DisabilityLevel',
  components: { SectionTitle },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    badge() {
      return (color) => ({
        background: `${color}22`,
        border: `1px solid ${color}`,
        color: color,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-semibold {
  font-weight: 600;
}
</style>
